import React, { useEffect, useState } from 'react';
import './ourTeam.css';
import { TeamMember } from '../../Components';
import LoadingPage from '../LoadingPage/LoadingPage';


function OurTeam() {
    // const apiUrl = 'http://localhost/server/testServer/team.php';
    const apiUrl = 'https://www.albarede.com/server/team.php';
    const [teams, setTeams] = useState([]);
    const [isLoading, setIsLoading] = useState(true); // حالة التحميل

    useEffect(() => {
        fetch(apiUrl, {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                setTeams(data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error fetching teams:', error);
            });
    }, []);
    if (isLoading) {
        return <LoadingPage />; // عرض صفحة التحميل أثناء التحميل
      }

    return (
        <div id="carouselExampleIndicators" className="carousel slide containerNew">
            <div className="carousel-inner">
                {teams.length > 0 ? (
                    teams.map((team, index) => (
                        <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={team.id}>
                            <TeamMember
                                key={team.id}
                                id={team.id}
                                title={team.title}
                                files={team.files}
                                position={team.position}
                                disc={team.disc}
                                email={team.email}
                            />
                        </div>
                    ))
                ) : (
                    <p>Loading...</p>
                )}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    );
}

export default OurTeam;
